import { axiosV3 } from '@/helpers/_core/axios';

export default class UserV3 {
  static SERVICE_NAME = 'userV3';

  constructor({ app }) {
    this.axios = axiosV3(app);
  }

  async getAllContexts() {
    return this.axios
      .withToken().get('/users/contexts')
      .then(r => r.data);
  }

  async updateUserInfo(body) {
    return this.axios
      .withToken().patch('/users/me', body)
      .then(r => r.data);
  }
}
